import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { iso } from "@/lib/wellness";

// A single reference period shared across every command center so that all
// date-aware views (habits, glow schedule, reviews, progress) stay in sync and
// "talk to each other" within a session. We persist only the chosen HORIZON
// (Day/Week/…); the date always opens on TODAY so views stay current and
// "today"-relative features (streaks, readiness) are reliable.
const PeriodContext = createContext(null);
const STORAGE_KEY = "cc.horizon.v1";

const readHorizon = () => {
  try { return localStorage.getItem(STORAGE_KEY) || "Day"; } catch { return "Day"; }
};

export const PeriodProvider = ({ children }) => {
  const [horizon, setHorizon] = useState(readHorizon);
  const [date, setDate] = useState(iso());

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, horizon); } catch { /* ignore */ }
  }, [horizon]);

  const goToday = useCallback(() => setDate(iso()), []);

  return (
    <PeriodContext.Provider value={{ horizon, setHorizon, date, setDate, goToday }}>
      {children}
    </PeriodContext.Provider>
  );
};

export const usePeriod = () => {
  const ctx = useContext(PeriodContext);
  if (!ctx) throw new Error("usePeriod must be used within a PeriodProvider");
  return ctx;
};
